import { useState, useLayoutEffect } from "react";
import { SolidButton } from "@components/button";
import { SimpleModal } from "@components/simple-modal";

export const CouponTicket = ({ coupon, exchangeCouponHandler }) => {
	const [containerClass, setContainerClass] = useState("");
	const [ticketClass, setTicketClass] = useState("");
	const [logoClass, setLogoClass] = useState("");
	const [exchangeModal, setExchangeModal] = useState(false);
	const [titleClass, setTitleClass] = useState("");
	const [discountClass1, setDiscountClass1] = useState("");
	const [discountClass2, setDiscountClass2] = useState("");
	const [descriptionClass, setDescriptionClass] = useState("");
	const [buttonClass, setButtonClass] = useState("");
	const [messageClass, setMessageClass] = useState("");

	useLayoutEffect(() => {
		window.addEventListener("resize", handleResize);
		handleResize();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const handleResize = () => {
		if (window.innerWidth > 640) {
			setContainerClass("border-[1px] border-black py-8 pl-12 pr-5");
			setTicketClass("flex items-center gap-x-12");
			setLogoClass("shrink h-full w-[200px]");
			setTitleClass("text-[22px] tracking-tight");
			setDiscountClass1("leading-6");
			setDiscountClass2("text-[21px] leading-6");
			setDescriptionClass(
				"noto-sans-tc-medium text-[12px] leading-4 text-[#a5a5a5]",
			);
			setButtonClass("px-14 py-1.5 text-[21px] mt-8 rounded-[10px]");
			setMessageClass("w-[291px] h-auto pt-20 pb-16");
		} else {
			setContainerClass(
				"border-[1px] border-black py-[3vw] pl-[3vw] pr-[2vw]",
			);
			setTicketClass("flex items-center gap-x-[4vw]");
			setLogoClass("shrink h-full w-[16vw]");
			setMessageClass("w-[45vw] h-auto pt-[15vw] pb-[10vw]");
			if (window.innerWidth > 460 && window.innerWidth <= 640) {
				setTitleClass("text-[21px] tracking-tight");
				setDiscountClass1("leading-6");
				setDiscountClass2("text-[20px] leading-6");
				setDescriptionClass(
					"noto-sans-tc-medium text-[12px] leading-4 text-[#a5a5a5]",
				);
				setButtonClass("px-12 py-1.5 text-[21px] mt-6 rounded-[8px]");
			} else if (window.innerWidth > 390 && window.innerWidth <= 460) {
				setTitleClass("text-[16px] tracking-tight");
				setDiscountClass1("leading-5");
				setDiscountClass2("text-[15px] leading-5");
				setDescriptionClass(
					"noto-sans-tc-medium text-[10px] leading-3 text-[#a5a5a5]",
				);
				setButtonClass("px-10 py-2 text-[16px] mt-6 rounded-[6px]");
			} else {
				setTitleClass("text-[15px] tracking-tight");
				setDiscountClass1("leading-5");
				setDiscountClass2("text-[14px] leading-5");
				setDescriptionClass(
					"noto-sans-tc-medium text-[9px] leading-3 text-[#a5a5a5]",
				);
				setButtonClass("px-9 py-1.5 text-[15px] mt-4 rounded-[5px]");
			}
		}
	};

	const onClickExchange = (couponId) => {
		exchangeCouponHandler(couponId);
		setExchangeModal(false);
	};

	return (
		<div className={containerClass}>
			<div className={ticketClass}>
				<img
					alt={"logo"}
					className={logoClass}
					src={coupon.coupon_item_image_url || window.assetUrl("/images/liff/coupon-wallet-page/logo.png")}
				/>
				<div className={"grow"}>
					<p className={titleClass}>{coupon.title}</p>
					<div className={"my-1"}>
						{coupon.coupon_title.split("\n").map((line, index) => (
							<p className={'font-semibold text=[5vw] mb-[5px]' + discountClass1} key={index}>
								{line}
							</p>
						))}
					</div>
					<div className={"my-1"}>
						{coupon.coupon_subtitle.split("\n").map((line, index) => (
							<p className={discountClass2} key={index}>
								{line}
							</p>
						))}
					</div>
					<div className={"mt-2.5"}>
						{coupon.description.split("\n").map((line, index) => (
							<p className={descriptionClass} key={index}>
								{line}
							</p>
						))}
					</div>
				</div>
			</div>
			{coupon.redeemable ?
				<div className={"flex justify-center"}>
					<SolidButton
						label={"兌換"}
						buttonClass={buttonClass}
						onClick={() => setExchangeModal(true)}
					/>
				</div>
				: null
			}
			<SimpleModal
				open={exchangeModal}
				setOpen={setExchangeModal}
				Content={
					<div className={"px-4 py-10 text-center"}>
						<div className={"flex justify-center"}>
							<img
								alt={"message"}
								className={messageClass}
								src={window.assetUrl(
									"/images/liff/coupon-wallet-page/message.png",
								)}
							/>
						</div>
						<div className={"flex items-center gap-x-8"}>
							<SolidButton
								onClick={()=>onClickExchange(coupon.id)}
								label={"確認"}
								buttonClass={buttonClass + " w-full"}
							/>
							<SolidButton
								onClick={() => setExchangeModal(false)}
								label={"返回"}
								buttonClass={buttonClass + " w-full"}
							/>
						</div>
					</div>
				}
			/>
		</div>
	);
};
